import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={15}
    height={13}
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m8.472.885 5.5 5.25c.156.157.25.344.25.563 0 .187-.094.375-.25.531l-5.5 5.25a.746.746 0 0 1-1.062-.031.746.746 0 0 1 .03-1.063l4.157-3.937H.972a.74.74 0 0 1-.75-.75c0-.438.313-.75.75-.75h10.625L7.441 1.979A.746.746 0 0 1 7.41.917c.28-.313.75-.313 1.062-.032"
      fill="#74787C"
    />
  </svg>
);
export default SVGComponent;
